import styled from '@emotion/styled'

import ButtonText from '@segment/matcha/components/ButtonText'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CardBase, * as Card from '@segment/matcha/recipes/Card'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const data = [
  {
    type: `Webinar`,
    title: `No Code Required: CustomerAI Predictions in Action.`,
    content: `Learn how trusted customer data unlocks the promise of AI to drive adaptive engagement across your entire business—helping you anticipate and act on future customer wants and needs and create more relevant customer experiences in minutes. `,
    ctaTitle: `View the webinar`,
    ctaUrl: `https://webinars.segment.com/segment/No-Code-Required-CustomerAI-Predictions-in-Action`,
  },
  {
    type: `Recipe`,
    title: `Use Twilio Segment to Anticipate a Customer's Readiness to Buy`,
    content: `In the competitive landscape of the FinTech industry, understanding customer behavior and predicting their readin...`,
    ctaTitle: `Use this recipe`,
    ctaUrl: `https://segment.com/recipes/use-segment-anticipate-readiness-to-buy/`,
  },
  {
    type: `Segment University`,
    title: `Use Predictions to Predict Customer Behavior`,
    content: `Unlock insights into customer behavior, fine-tune marketing efforts, and maximize revenue opportunities with Predictions.`,
    ctaTitle: `View this course`,
    ctaUrl: `https://university.segment.com/use-predictions-to-predict-customer-behavior`,
  },
]

const TITLE = `Resources`

const Resources = () => {
  return (
    <SectionBase variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h2">{TITLE}</CopyText.Heading>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <StyledColumnTrack
          columns={1}
          overrides={{
            lg: 3,
          }}
        >
          {data.map(({ type, title, content, ctaTitle, ctaUrl }, key) => (
            <CardBase href={ctaUrl} key={key}>
              <Card.Body>
                <Card.Accessories>
                  <Card.AccessoriesRow>
                    <Card.Label>{type}</Card.Label>
                  </Card.AccessoriesRow>
                </Card.Accessories>
                <Card.Copy>
                  <Card.Headline tag="h3">{title}</Card.Headline>
                  <Card.Description>{content}</Card.Description>
                </Card.Copy>
                <Card.Action alignment="left">
                  <ButtonText iconEnd={ChevronRightIcon}>{ctaTitle}</ButtonText>
                </Card.Action>
              </Card.Body>
            </CardBase>
          ))}
        </StyledColumnTrack>
      </Section.Contents>
    </SectionBase>
  )
}

const StyledColumnTrack = styled(ColumnTrack)`
  max-width: 1120px;
  margin: 0 auto;
`

export default Resources
